import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function usePublicAPI() {
  const { language } = useStorage();

  function getLoginPrivacyPolicyFromRemote() {
    const url = `https://raw.githubusercontent.com/menurapp/public/main/privacidade/cardapio/login/README_${language.tag}.md`;

    return axios({
      url,
      method: 'get',
      responseType: 'text',
    });
  }

  function getPayCardPrivacyPolicyFromRemote() {
    const url = `https://raw.githubusercontent.com/menurapp/public/main/privacidade/cardapio/pagamento/cartao/README_${language.tag}.md`;

    return axios({
      url,
      method: 'get',
      responseType: 'text',
    });
  }

  function getPayWalletPrivacyPolicyFromRemote() {
    const url = `https://raw.githubusercontent.com/menurapp/public/main/privacidade/cardapio/pagamento/carteira_digital/README_${language.tag}.md`;

    return axios({
      url,
      method: 'get',
      responseType: 'text',
    });
  }

  function getAddressPrivacyPolicyFromRemote() {
    const url = `https://raw.githubusercontent.com/menurapp/public/main/privacidade/cardapio/pagamento/cartao/README_${language.tag}.md`;

    return axios({
      url,
      method: 'get',
      responseType: 'text',
    });
  }

  function getPhoneNumberPrivacyPolicyFromRemote() {
    const url = `https://raw.githubusercontent.com/menurapp/public/main/privacidade/cardapio/pagamento/cartao/README_${language.tag}.md`;

    return axios({
      url,
      method: 'get',
      responseType: 'text',
    });
  }

  return {
    getLoginPrivacyPolicyFromRemote,
    getPayCardPrivacyPolicyFromRemote,
    getPayWalletPrivacyPolicyFromRemote,
    getAddressPrivacyPolicyFromRemote,
    getPhoneNumberPrivacyPolicyFromRemote,
  };
}

export { usePublicAPI };
